import Button from '../../../components/base/Button';

export default function HeroSection() {
  const handleWhatsAppClick = () => {
    window.open('https://wa.me/5511993706525', '_blank');
  };

  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.6)), url('https://readdy.ai/api/search-image?query=Professional%20private%20investigator%20office%20with%20modern%20desk%2C%20confidential%20documents%2C%20magnifying%20glass%2C%20and%20subtle%20lighting%20creating%20atmosphere%20of%20trust%20and%20discretion%2C%20clean%20minimalist%20background%20with%20warm%20professional%20lighting%2C%20high%20quality%20photography%20style&width=1920&height=1080&seq=hero-bg&orientation=landscape')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 w-full">
        <div className="text-center text-white">
          <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
            Você Desconfia.<br />
            <span className="text-red-500">Você Merece Saber a Verdade.</span>
          </h1>
          
          <p className="text-xl md:text-2xl mb-8 max-w-3xl mx-auto text-gray-200">
            Investigação conjugal <strong>100% discreta</strong> e confidencial. 
            Trabalho realizado com <strong>total sigilo</strong>.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-12">
            <Button onClick={handleWhatsAppClick} size="lg" className="text-lg px-10 py-4">
              <i className="ri-phone-line mr-2"></i>
              Falar com Especialista Agora
            </Button>
            <Button 
              onClick={handleWhatsAppClick}
              variant="outline" 
              size="lg" 
              className="text-lg px-10 py-4 border-white text-white hover:bg-white hover:text-gray-900"
            >
              <i className="ri-shield-check-line mr-2"></i>
              Sigilo 100% Garantido
            </Button>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8 max-w-4xl mx-auto">
            <div className="text-center">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-eye-off-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Investigação Discreta</h3>
              <p className="text-gray-300">Com técnicas eficazes e profissionais</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-file-text-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Evidências Profissionais</h3>
              <p className="text-gray-300">Relatório técnico com evidências admissíveis, quando aplicável</p>
            </div>
            
            <div className="text-center">
              <div className="w-16 h-16 bg-red-600 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className="ri-heart-line text-2xl text-white"></i>
              </div>
              <h3 className="text-lg font-semibold mb-2">Suporte Emocional</h3>
              <p className="text-gray-300">Orientação completa para tomar a melhor decisão</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
